import api from 'axios'
let moment = require('moment')

const state = {
  list: {},
  selectedLedger: {
    name: null
  }
}

const actions = {
  getLedgers ({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      api.get('/ledger')
        .then(
          response => {
            commit('SET_LEDGERS', response.data.ledgers)
            resolve(response.data)
          }
        )
        .catch(
          error => {
            (error.response) ? reject(error.response.data) : reject(error)
          }
        )
    })
  },
  getLedger ({ commit, state, dispatch }, id) {
    if (state.selectedLedger.name && (Number(id) !== Number(state.selectedLedger.id))) {
      commit('UNSET_SELECTED_LEDGER')
    }
    return new Promise((resolve, reject) => {
      api.get('/ledger/' + id)
        .then(
          response => {
            resolve(response.data)
            commit('SET_SELECTED_LEDGER', response.data.ledger)
          }
        )
        .catch(
          error => {
            (error.response) ? reject(error.response.data) : reject(error)
          }
        )
    })
  },
  createLedger ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.post('/ledger', data)
        .then(
          response => {
            dispatch('getLedgers')
            resolve(response.data)
          }
        )
        .catch(
          error => {
            (error.response) ? reject(error.response.data) : reject(error)
          }
        )
    })
  },
  createExampleLedger ({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      api.post('/ledger/create-example', { 'referenceDate': moment().format('YYYY-MM-DD') })
        .then(
          response => {
            dispatch('getLedgers')
            resolve(response.data)
          }
        )
        .catch(
          error => {
            (error.response) ? reject(error.response.data) : reject(error)
          }
        )
    })
  },
  updateLedger ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.post('/ledger/' + data.id, data)
        .then(
          response => {
            dispatch('getLedgers')
            commit('SET_SELECTED_LEDGER', response.data.ledger)
            resolve(response.data)
          }
        )
        .catch(
          error => {
            (error.response) ? reject(error.response.data) : reject(error)
          }
        )
    })
  },
  shareLedgerWith ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.post('/ledger/' + data.ledgerId + '/share', data.shareWith)
        .then(
          response => {
            commit('SET_SELECTED_LEDGER', response.data.ledger)
            resolve(response.data)
          }
        )
        .catch(
          error => {
            (error.response) ? reject(error.response.data) : reject(error)
          }
        )
    })
  },
  unshareLedgerWith ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.post('/ledger/' + data.ledgerId + '/unshare', { user_id: data.userId })
        .then(
          response => {
            commit('SET_SELECTED_LEDGER', response.data.ledger)
            resolve(response.data)
          }
        )
        .catch(
          error => {
            (error.response) ? reject(error.response.data) : reject(error)
          }
        )
    })
  },
  destroyLedger ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.post('/ledger/' + data.ledgerId + '/destroy', { password: data.password })
        .then(
          response => {
            commit('UNSET_SELECTED_LEDGER')
            dispatch('getLedgers')
            resolve(response.data)
          }
        )
        .catch(
          error => {
            (error.response) ? reject(error.response.data) : reject(error)
          }
        )
    })
  },
  createExpense ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      data.expense.createdAtLocalTimestamp = moment().format('YYYY-MM-DD HH:mm:ss')
      api.post('/ledger/' + data.ledgerId + '/expense', data.expense)
        .then(
          response => {
            dispatch('getLedger', data.ledgerId)
            resolve(response.data)
          }
        )
        .catch(
          error => {
            (error.response) ? reject(error.response.data) : reject(error)
          }
        )
    })
  },
  updateExpenseLabel ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.post('/ledger/' + data.ledgerId + '/expense/' + data.expenseId + '/label', { label: data.label })
        .then(
          response => {
            dispatch('getLedger', data.ledgerId)
            resolve(response.data)
          }
        )
        .catch(
          error => {
            (error.response) ? reject(error.response.data) : reject(error)
          }
        )
    })
  },
  updateExpenseDate ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.post('/ledger/' + data.ledgerId + '/expense/' + data.expenseId + '/occurrence/' + data.expenseDateId + '/date', { date: data.date, isNotDaySpecific: data.isNotDaySpecific })
        .then(
          response => {
            dispatch('getLedger', data.ledgerId)
            resolve(response.data)
          }
        )
        .catch(
          error => {
            (error.response) ? reject(error.response.data) : reject(error)
          }
        )
    })
  },
  updateExpenseEstimate ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.post('/ledger/' + data.ledgerId + '/expense/' + data.expenseId + '/occurrence/' + data.expenseDateId + '/estimate', { estimate: data.estimate, updateType: data.updateType })
        .then(
          response => {
            dispatch('getLedger', data.ledgerId)
            resolve(response.data)
          }
        )
        .catch(
          error => {
            (error.response) ? reject(error.response.data) : reject(error)
          }
        )
    })
  },
  destroyExpenseOccurrence ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.post('/ledger/' + data.ledgerId + '/expense/' + data.expenseId + '/occurrence/' + data.expenseDateId + '/destroy')
        .then(
          response => {
            dispatch('getLedger', data.ledgerId)
            resolve(response.data)
          }
        )
        .catch(
          error => {
            (error.response) ? reject(error.response.data) : reject(error)
          }
        )
    })
  },
  destroyCurrentAndFutureExpenseOccurrence ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.post('/ledger/' + data.ledgerId + '/expense/' + data.expenseId + '/occurrence/' + data.expenseDateId + '/destroyCurrentAndFuture')
        .then(
          response => {
            dispatch('getLedger', data.ledgerId)
            resolve(response.data)
          }
        )
        .catch(
          error => {
            (error.response) ? reject(error.response.data) : reject(error)
          }
        )
    })
  },
  destroyAllExpenseOccurrences ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.post('/ledger/' + data.ledgerId + '/expense/' + data.expenseId + '/destroy')
        .then(
          response => {
            dispatch('getLedger', data.ledgerId)
            resolve(response.data)
          }
        )
        .catch(
          error => {
            (error.response) ? reject(error.response.data) : reject(error)
          }
        )
    })
  },
  createPayment ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.post('/ledger/' + data.ledgerId + '/expense/' + data.expenseId + '/payment', data.payment)
        .then(
          response => {
            dispatch('getLedger', data.ledgerId)
            resolve(response.data)
          }
        )
        .catch(
          error => {
            (error.response) ? reject(error.response.data) : reject(error)
          }
        )
    })
  },
  destroyPayment ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.post('/ledger/' + data.ledgerId + '/expense/' + data.expenseId + '/payment/' + data.paymentId + '/destroy')
        .then(
          response => {
            dispatch('getLedger', data.ledgerId)
            resolve(response.data)
          }
        )
        .catch(
          error => {
            (error.response) ? reject(error.response.data) : reject(error)
          }
        )
    })
  }
}

const mutations = {
  SET_LEDGERS (state, data) {
    state.list = data
  },
  SET_SELECTED_LEDGER (state, data) {
    state.selectedLedger = data
  },
  UNSET_SELECTED_LEDGER (state) {
    state.selectedLedger = { name: null }
  },
  UNSET_LEDGER_LIST (state) {
    state.list = {}
  }
}

export default {
  state,
  actions,
  mutations
}
